import { render, staticRenderFns } from "./Launcher.vue?vue&type=template&id=482a1a5c&"
import script from "./Launcher.vue?vue&type=script&lang=js&"
export * from "./Launcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports